import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ConfirmComponent } from "./components/confirm-component/confirm-component";
import { UserService } from './services/user-service';
import { UserStore } from './stores/user-store';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ConfirmComponent],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  private readonly userService = inject(UserService);
  private readonly userStore = inject(UserStore);

  constructor() {
    /*this.userService.me().subscribe({
      next: user => {
        this.userStore.update(user);
      },
      error: err => {
        console.error(err);
      }
    });*/
  }
}
